import React, { useReducer, useState } from "react"
import { Form, Button } from "react-bootstrap"
import Alerts from "../Alerts"
import * as styles from "./Styles/Settings.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

export default (props) => {
  const [passwords, dispatchPasswords] = useReducer(passwordReducer, {
    password: "",
    password_confirmation: "",
  })

  function passwordReducer(before, action) {
    switch (action.type) {
      case "password":
        return { ...before, password: action.value }
      case "passwordConfirmation":
        return { ...before, password_confirmation: action.value }
      default:
        return before
    }
  }

  return (
    <React.Fragment>
      <Alerts error={props.error} notice={props.notice} />
      <div className={cn("l-centering", "l-flex--column", "background")}>
        <Form action={props.path} method="POST" className={styles.form}>
          <Form.Group controlId="signInForm.password">
            <Form.Label>パスワード</Form.Label>
            <Form.Control
              type="password"
              placeholder="半角英数字記号 10文字以上"
              name="password"
              autoComplete="new-password"
              value={passwords.password}
              onChange={(e) =>
                dispatchPasswords({ type: "password", value: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="signInForm.passwordConfirm">
            <Form.Label>パスワード（確認）</Form.Label>
            <Form.Control
              type="password"
              placeholder="パスワード再入力"
              name="password_confirmation"
              autoComplete="new-password"
              value={passwords.password_confirmation}
              onChange={(e) =>
                dispatchPasswords({
                  type: "passwordConfirmation",
                  value: e.target.value,
                })
              }
            />
          </Form.Group>
          <input
            type="hidden"
            name="authenticity_token"
            value={props.authenticity_token}
          />
          <input type="hidden" name="token" value={props.token} />
          <Button type="submit" className="l-primary-button--admin">
            再設定する
          </Button>
        </Form>
      </div>
    </React.Fragment>
  )
}
